/* import __COLOCATED_TEMPLATE__ from './impact-filter.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'ember-intl/services/intl';
import { ProjectedConversationsRanking } from 'embercom/lib/suggestions/constants';

interface Signature {
  Args: {
    impactLevels: ProjectedConversationsRanking[];
    onImpactChange: (value: ProjectedConversationsRanking | 'all') => void;
  };
}

export default class ImpactFilter extends Component<Signature> {
  @service declare intl: IntlService;

  get HIGH_IMPACT(): ProjectedConversationsRanking {
    return ProjectedConversationsRanking.High;
  }

  get MEDIUM_IMPACT(): ProjectedConversationsRanking {
    return ProjectedConversationsRanking.Medium;
  }

  get LOW_IMPACT(): ProjectedConversationsRanking {
    return ProjectedConversationsRanking.Low;
  }

  get isAllImpactSelected(): boolean {
    return this.args.impactLevels.length === 0;
  }

  get impactLabel(): string {
    if (this.args.impactLevels.length === 0) {
      return this.intl.t('components.reporting.automation.optimize-suggestions.filter.impact.all');
    }
    if (this.args.impactLevels.length === 1) {
      switch (this.args.impactLevels[0]) {
        case ProjectedConversationsRanking.High:
          return this.intl.t('ai-agent.suggestions.list-item.projected-conversations-ranking.high');
        case ProjectedConversationsRanking.Medium:
          return this.intl.t(
            'ai-agent.suggestions.list-item.projected-conversations-ranking.medium',
          );
        case ProjectedConversationsRanking.Low:
          return this.intl.t('ai-agent.suggestions.list-item.projected-conversations-ranking.low');
      }
    }
    // Multiple selections
    return this.intl.t('components.reporting.automation.optimize-suggestions.filter.selected', {
      count: this.args.impactLevels.length,
    });
  }

  @action
  handleImpactChange(value: ProjectedConversationsRanking | 'all'): void {
    this.args.onImpactChange(value);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::Filters::ImpactFilter': typeof ImpactFilter;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/filters/impact-filter': typeof ImpactFilter;
  }
}
